import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import Navigation from "../Navigation/Navigation";
import VerordnungMonitoringDto from "./VerordnungMonitoringDto";
import VerordnungMonitoringService from "./VerordnungMonitoringService";

import './Uebersicht/UebersichtMonitoringOstral'
import './Uebersicht/UebersichtMonitoringGp'
import './Verbrauch/VerbrauchMonitoring'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/VerticalNavigation/VerticalNavigation.js'
import AuthorizationFilter from "../Authorization/AuthorizationFilter";

export default class VerordnungMonitoring extends WebComponent {

  constructor() {
    super()
    this.verordnungMonitoringService = new VerordnungMonitoringService()
  }

  get translationFile() {
    return './views/VerordnungMonitoring/i18n.json'
  }

  get subsites() {
    const roles = new AuthorizationFilter().roles
    return {
      Kontingentierung: {
        render: () => {
          if (roles.OSTRAL || roles.BWL) {
            return html`<eko-frontend-kontingentierung-uebersicht-ostral .verordnung="${this.verordnung}"></eko-frontend-kontingentierung-uebersicht-ostral>`
          } else if (roles.VNB) {
            return html`<a href="https://services.isceco.admin.ch/jira-pr/browse/FAENERGY-815">FAENERGY-815</a>`
          } else if (roles.GP) {
            return html`<eko-frontend-kontingentierung-uebersicht-gp .verordnung="${this.verordnung}"></eko-frontend-kontingentierung-uebersicht-gp>`
          }
          return html`<eko-frontend-not-authorized></eko-frontend-not-authorized>`
        }
      },
      VerbrauchMonitoring: {
        render: () => html`
          <eko-frontend-kontingentierung-monitoring .verordnung="${this.verordnung}"></eko-frontend-kontingentierung-monitoring>`
      }
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    if (getNavigationId() === undefined) {
      this.verordnungMonitoringService.getActiveId()
        .then(id => id ? navigate({to: getNavigationHash(), id}) : this.render())
    } else {
      Promise.all([
        this.verordnungMonitoringService.list(),
        this.verordnungMonitoringService.read(getNavigationId())
      ]).then(([verordnungen, verordnung]) => {
        this.verordnungen = verordnungen.map(v => new VerordnungMonitoringDto(v))
        this.verordnung = new VerordnungMonitoringDto(verordnung)
        this.render()
      })
    }
  }

  getTemplate() {
    if (this.verordnung === undefined) {
      return html`
        <isceco-title id="page-title" text="${this.i18n.translate('kontingentierung.verordnung.empty')}">
        </isceco-title>
      `
    }

    const subsite = this.subsites[getNavigationHash()]
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('kontingentierung.verordnung.title',
        {srNummer: this.verordnung.srNummer, von: formatDate(this.verordnung.geltungsdauerVon), bis: formatDate(this.verordnung.geltungsdauerBis)})}">
        <isceco-button size="small" icon="list" variant="secondary"
                       text="${this.i18n.translate('kontingentierung.verordnung.select')}"
                       @click="${() => this.toggleVerordnungSelectionDialog(true)}"
        ></isceco-button>
      </isceco-title>
      <div class="detail-flex-box">
        <div class="detail-child-left">
          <isceco-vertical-navigation .items="${this._getNavItems()}">
          </isceco-vertical-navigation>
        </div>
        <div class="detail-child-right">
          ${subsite.render()}
        </div>
      </div>
      ${this.getVerordnungSelectionDialog()}
    `
  }

  toggleVerordnungSelectionDialog(visible) {
    this.showVerordnungSelection = visible
    this.render()
  }

  getVerordnungSelectionDialog() {
    if (!this.showVerordnungSelection) {
      return html``
    }
    const items = this.verordnungen.map(v => ({
      value: v.id,
      name: this.i18n.translate('kontingentierung.verordnung.select.' + v.status.toLowerCase(),
        {srNummer: v.srNummer, von: formatDate(v.geltungsdauerVon), bis: formatDate(v.geltungsdauerBis)})
    }))
    return html`
      <isceco-dialog id="verordnung-selection-dialog"
                     header="${this.i18n.translate('kontingentierung.verordnung.select')}"
                     confirm-button="${this.i18n.translate('base.button.select')}"
                     cancel-button="${this.i18n.translate('base.button.cancel')}"
                     @submit="${this._selectVerordnung}">
        <isceco-dropdown id="verordnung-selection"
                         .value="${this.verordnung.id}"
                         .items="${items}"
        ></isceco-dropdown>
      </isceco-dialog>
    `
  }

  _selectVerordnung = e => {
    if (!e.detail.confirmed) {
      this.toggleVerordnungSelectionDialog(false)
      return
    }
    const id = document.getElementById('verordnung-selection')?.getValue()
    if (id === this.verordnung.id) {
      this.toggleVerordnungSelectionDialog(false)
    } else {
      navigate({to: getNavigationHash(), id})
    }
  }

  _getNavItems = () => {
    const roles = new AuthorizationFilter().roles
    return [
      {
        text: this.i18n.translate('kontingentierung.uebersicht.title'),
        icon: 'stream',
        url: `${Navigation.ROUTES.monitoringVerordnung.url}/${getNavigationId()}`,
        suburls: [Navigation.ROUTES.monitoringVerordnung.url],
        roles: [roles.BWL, roles.OSTRAL, roles.GP]
      },
      {
        text: this.i18n.translate('kontingentierung.monitoring.title'),
        icon: 'chartline',
        url: `${Navigation.ROUTES.monitoringVerbrauch.url}/${getNavigationId()}`,
        suburls: [Navigation.ROUTES.monitoringVerbrauch.url],
        roles: [roles.BWL, roles.OSTRAL]
      },
      {
        text: this.i18n.translate('kontingentierung.monitoringAusnahme.title'),
        icon: 'chartline',
        url: 'https://services.isceco.admin.ch/jira-pr/browse/FAENERGY-944',
        roles: [roles.BWL, roles.OSTRAL]
      }
    ].filter(i => i.roles.some(r => r))
  }
}

customElements.define('eko-frontend-kontingentierung', VerordnungMonitoring)
